<template>
  <div class="upload">
    <input
      style="display: none"
      type="file"
      multiple
      ref="file"
      @change="onFileChoose"
    />
    <button
      @click="openFileChooser"
      @drop.prevent="dragDrop"
      @dragover.prevent
      :disabled="loading"
      class="f-default"
    >
      <!-- <i class="bi bi-upload mr-2" v-if="!loading"></i> -->
      <span v-html="text" v-if="!loading"></span>
      <pulse-loader
        color="#707070c9"
        :loading="loading"
        class="loading-button"
      ></pulse-loader>
    </button>
  </div>
</template>
<script>
import { mixins } from "@/mixins/mixins";
import api from "@/services/api";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  components: {
    PulseLoader,
  },
  props: {
    text: {
      type: String,
      default: () =>
        "Clique ou arraste arquivos  <br> <small>(Tamanho maximo de arquivo é de 500mb)</small>",
    },
    multiple: {
      type: Boolean,
      default: () => false,
    },
  },

  mixins: [mixins],
  data: () => {
    return {
      file: "",
      fileData: "",
      loading: false,
    };
  },
  methods: {
    dragDrop(event) {
      let files = Array.from(event.dataTransfer.files);
      this.upload(files);
    },
    onFileChoose(event) {
      let files = Array.from(event.target.files);
      this.upload(files);
    },
    openFileChooser() {
      if (this.lockFileClick) return;
      this.$refs.file.click();
    },
    async upload(files) {
      this.loading = true;
      for (let fil of Array.from(files)) {
        try {
          const { data } = await api.uploadFileSignedUrl(fil.name);
          await api.putFile(data.url, fil);
        } catch (error) {
          this.errorCatch(error);
        } finally {
          this.loading = false;
          this.file = "";
        }
      }
    },
  },
};
</script>
<style lang="scss">
.upload {
  button {
    width: 100%;
    height: 100px;
    background: transparent;
    border: 2px dashed #EAECEC;
    border-radius: 3px;
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;

    text-align: center;


    color: #6c757d;
  }
}
</style>